import { styled } from '@mui/material/styles';
import { PAGE_Z_INDEX } from 'pages/document/page/components/StyledComponents';

import IconButton from '@mui/material/IconButton';

export const GridLayout = styled('div', { label: 'GridLayout' })(() => ({
  position: 'absolute',
  inset: 0,
  zIndex: PAGE_Z_INDEX.GRID,
}));

export const GridActionIcon = styled(IconButton, { label: 'GridActionIcon' })(() => ({
  zIndex: 3,
  position: 'absolute',
  width: 18,
  height: 18,
  padding: 2,
}));
